import PropTypes from 'prop-types';


const FieldTooltip = ({ text = '', ref = undefined }) => (
  <div className="render-field-tooltip" ref={ref}>
    <div className="tooltip-text">{text}</div>
  </div>
);


FieldTooltip.propTypes = {
  text: PropTypes.string,
};

export default FieldTooltip;
